import { computed } from '@vue/composition-api';
import { getInitials } from '@/_core/utils/misc';

export class CurrentUserState {
    userId: string = '';
    userShortId: string = '';

    fullName: string = '';
    loginName: string = '';

    email: string = '';

    canCreateWorkspaces: boolean = false;

    hasJiraAuthToken: boolean = false;

    userIsDomainControlled: boolean = false;

    ssoEnabledForUser: boolean = false;
    ssoRequiredForUser: boolean = false;

    userSessionId: string = ''; //TODO: ???
    userIpAddress: string = '';

    dismissedQuickTipKeys: string[] = [];

    public userInitials = computed(() => {
        return getInitials(this.fullName);
    });
}
